const NEW_YORK_TIME = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  weekday: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const WEEKDAYS = new Set(['Mon', 'Tue', 'Wed', 'Thu', 'Fri']);

/**
 * True during the regular US equity session: 09:30 inclusive to 16:00
 * exclusive in America/New_York. Intl supplies the applicable EST/EDT offset.
 */
export function isUsMarketHoursUtc(now: Date): boolean {
  const parts = NEW_YORK_TIME.formatToParts(now);
  const weekday = parts.find((part) => part.type === 'weekday')?.value;
  const hour = Number(parts.find((part) => part.type === 'hour')?.value);
  const minute = Number(parts.find((part) => part.type === 'minute')?.value);

  if (!weekday || !WEEKDAYS.has(weekday) || !Number.isInteger(hour) || !Number.isInteger(minute)) {
    return false;
  }

  const minutesSinceMidnight = hour * 60 + minute;
  return minutesSinceMidnight >= 9 * 60 + 30 && minutesSinceMidnight < 16 * 60;
}
